import api from './api'

export const emailSegmentService = {
  getAllSegments: async () => {
    const response = await api.get('/email-segments')
    return response.data
  },

  getSegmentById: async (id) => {
    const response = await api.get(`/email-segments/${id}`)
    return response.data
  },

  getSegmentAnalytics: async (id) => {
    const response = await api.get(`/email-segments/${id}/analytics`)
    return response.data
  },

  getSegmentContacts: async (id, params = {}) => {
    const response = await api.get(`/email-segments/${id}/contacts`, { params })
    return response.data
  },

  createSegment: async (data) => {
    const response = await api.post('/email-segments', data)
    return response.data
  },

  updateSegment: async (id, data) => {
    const response = await api.put(`/email-segments/${id}`, data)
    return response.data
  },

  deleteSegment: async (id) => {
    const response = await api.delete(`/email-segments/${id}`)
    return response.data
  },

  previewRules: async (rules) => {
    const response = await api.post('/email-segments/preview', { rules })
    return response.data
  },

  previewSegment: async (id) => {
    const response = await api.post(`/email-segments/${id}/preview`)
    return response.data
  }
}
